module.exports = __webpack_public_path__ + "static/media/IMG_037.08c47850.JPG";